// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip-1MqtN","bottom-center":"bottom-center-1BZ8k tooltip-1MqtN","top-center":"top-center-2477c tooltip-1MqtN","middle-right":"middle-right-3VTje tooltip-1MqtN","middle-left":"middle-left-2IxoV tooltip-1MqtN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/tethers/tooltip.scss
 ** module id = 49
 ** module chunks = 0
 **/